import apiClient from './apiClient';

const API_URL = '/tramites/amparo';

// Listar / filtrar trámites de Amparo por mora (ANSES)
export const getTramitesAmparo = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye el trámite de fondo y el checklist)
export const getTramiteAmparoById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Los 7 subtipos con su etiqueta, para el selector del alta (no se hardcodean en el frontend)
export const getSubtiposAmparo = async () => {
    const response = await apiClient.get(`${API_URL}/subtipos`);
    return response.data;
};

// Preview en vivo del checklist de documentación (siempre los mismos formularios)
export const previewChecklistAmparo = async () => {
    const response = await apiClient.get(`${API_URL}/formularios`);
    return response.data;
};

/**
 * El amparo promovido por un trámite de fondo, o null si no tiene ninguno.
 *
 * El backend responde 204 cuando no hay amparo (es una ausencia esperada, no un error), y axios
 * deja `data` como un string vacío: hay que normalizarlo a null o el llamador cree que hay objeto.
 * Lo consume el chip "Amparo iniciado" de la ficha del trámite de fondo.
 */
export const getAmparoPorTramiteFondo = async (idTramiteFondo) => {
    const response = await apiClient.get(`${API_URL}/por-tramite/${idTramiteFondo}`);
    return response.status === 204 || !response.data ? null : response.data;
};

// Crear un nuevo trámite de Amparo por mora
export const crearTramiteAmparo = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Amparo:', error.response?.data || error.message);
        throw error;
    }
};

// Editar subtipo, trámite de fondo, expediente y titular (no el cliente)
export const actualizarTramiteAmparo = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Seguimiento editable (expediente, UDAI, pronto despacho, juzgado, respuesta del organismo,
// tiempo comprometido y corrección de fechas de hitos). Independiente del cambio de estado.
export const actualizarSeguimientoAmparo = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}/seguimiento`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable)
export const actualizarComentariosAmparo = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Avanzar de estado: cada transición manda su propio mini-formulario (destino + dato de la etapa)
export const avanzarEstadoAmparo = async (id, dto) => {
    const response = await apiClient.patch(`${API_URL}/${id}/estado`, dto);
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistAmparo = async (idItem, presentado, idArchivo) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

const amparoService = {
    getTramitesAmparo,
    getTramiteAmparoById,
    getSubtiposAmparo,
    previewChecklistAmparo,
    getAmparoPorTramiteFondo,
    crearTramiteAmparo,
    actualizarTramiteAmparo,
    actualizarSeguimientoAmparo,
    actualizarComentariosAmparo,
    avanzarEstadoAmparo,
    actualizarChecklistAmparo,
};

export default amparoService;
